var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rootElement",class:_vm.rootClass},[_c('src-card-list',{attrs:{"id":"srcCardList","locale":"pt_BR","card-brands":_vm.cardBrands,"display-add-card":"true","display-preferred-card":"true","display-sign-out":"true","card-selection-type":"radioButton","src-digital-card-id":"","display-header":"true","unaccepted-card-type":"DEBIT"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }